module.exports = __webpack_public_path__ + "static/media/hero-big-subscribed.af06a902.webp";